import styled from 'styled-components'
import { rem, BaseColor, spacing, themeColor, transitionDuration, transitions, opaqueColor, Typography } from '~theme'

export const Overlay = styled.div<{ isVisible: boolean; zIndex: number }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  position: fixed;
  z-index: ${props => props.zIndex};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${props => opaqueColor(themeColor(BaseColor.overlay)(props), 50)};
  opacity: ${props => (props.isVisible ? '1' : '0')};
  pointer-events: ${props => (props.isVisible ? 'all' : 'none')};
  transition: opacity ${transitionDuration}ms ease-in-out;
`

export const Container = styled.div<{ isExpanded: boolean; isVisible: boolean }>`
  background: ${themeColor(BaseColor.surfaceBg)};
  border-radius: ${rem(8)} ${rem(8)} 0 0;
  padding-bottom: 0;
  width: 100%;
  max-height: ${props => {
    if (props.isVisible) {
      return props.isExpanded ? `calc(100% - ${spacing(1)(props)})` : '50%'
    }
    return '0'
  }};
  ${transitions(['max-height'], 2)};
`

export const Scroller = styled.div`
  height: 100%;
  width: 100%;
  padding: ${spacing()};
  overflow-y: scroll;
  user-select: none;
`

export const Heading = styled.div`
  padding: ${spacing(2.5)} ${spacing()} ${spacing(1.625)};
  border-bottom: 1px solid ${themeColor(BaseColor.shade_30)};
  position: relative;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
  touch-action: none;

  &:before {
    content: '';
    width: ${rem(30)};
    height: ${rem(6)};
    background: ${themeColor(BaseColor.max)};
    display: block;
    position: absolute;
    left: calc(50% - ${rem(15)});
    top: ${spacing(0.5)};
    border-radius: 999px;
  }
`

export const Title = styled.div`
  flex-grow: 1;
  ${Typography.titleMedium};
  ${Typography.textSemiStrong};
  color: ${themeColor(BaseColor.shade_70)};
`

export const BackButton = styled.div<{ isVisible: boolean }>`
  flex-shrink: 0;
  margin-right: ${props => (props.isVisible ? spacing() : '0')};
  overflow: hidden;
  width: ${props => (props.isVisible ? rem(20) : '0')};
  ${transitions(['width', 'margin-right'])};
`
